import React from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';

const Servicesstep = ({ steps }) => {

  const location = useLocation();
  const isApplyForLetterOfCredit = location.pathname === "/applyforletterofcredit";

  return (
    <>
      <section className='service-steps'>
        <Container>
          <Row>
            <Col lg={4}>
              <div className="head-title my-0 my-lg-5 mb-5 text-start">
                <div className="sup">Quick Steps</div>
                <h2>
                  <span className="text-gradient">How It Works ?</span>
                </h2>
              </div>
            </Col>
              {isApplyForLetterOfCredit && (
                <Col lg={4} md={6} className='mb-4'>
                  <Card className="extinfo">
                    <Card.Body>
                      <Card.Title as="h3">Cost of Letter of Credit (LC)</Card.Title>
                      <Card.Text>
                        <ul>
                          <li>For invoices below $60k: 850 x rate = Transaction fee</li>
                          <li>For invoices above $60K: $450 + (amount)0.75% = Transaction Fee</li>
                          <li>Amendments: $150</li>
                        </ul>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              )}
            {steps.map((step, index) => (
              <Col lg={4} md={6} key={index} className='mb-4'>
                <Card>
                  <Card.Body>
                    <div className="toper-box">
                      <Badge pill bg="dark">{step.stepbadgeText}</Badge>
                      <div className="img">
                        <img src={step.stepimageSrc} alt={`Step ${step.stepNumber}`} />
                      </div>
                    </div>
                    <Card.Title as="h3">{step.steptitle}</Card.Title>
                    <Card.Text dangerouslySetInnerHTML={{ __html: step.steptext }}></Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Servicesstep;
